import type { LevelConfig } from '../index';

export const level10: LevelConfig = {
  id: 'level_10',
  stage: '2',
  mapId: 'map_10',
  timeLimitSec: 180,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'activate_terminals', target: 3 },
  enemies: [
    { type: 'BASIC_SCAMMER', position: { x: 300, y: 300 }, patrolPath: [{ x: 300, y: 300 }, { x: 300, y: 500 }] },
    { type: 'BASIC_SCAMMER', position: { x: 600, y: 400 }, patrolPath: [{ x: 600, y: 400 }, { x: 600, y: 600 }] },
    { type: 'BASIC_SCAMMER', position: { x: 450, y: 700 }, patrolPath: [{ x: 450, y: 700 }, { x: 450, y: 850 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 750, y: 300 }, patrolPath: [{ x: 750, y: 300 }, { x: 750, y: 500 }] },
    { type: 'ARMORED_SCAMMER', position: { x: 300, y: 600 }, patrolPath: [{ x: 300, y: 600 }, { x: 500, y: 600 }] },
    { type: 'SUPPORT_SCAMMER', position: { x: 550, y: 500 }, patrolPath: [{ x: 550, y: 500 }, { x: 550, y: 700 }] },
    { type: 'SPAMMER', position: { x: 700, y: 650 }, patrolPath: [{ x: 700, y: 650 }, { x: 850, y: 650 }] },
    { type: 'INVESTOR_SCAMMER', position: { x: 400, y: 450 }, patrolPath: [{ x: 400, y: 450 }, { x: 400, y: 650 }] },
  ],
  loot: [
    ...Array.from({ length: 30 }, (_, i) => ({
      type: 'COIN' as const,
      position: { x: 180 + (i % 6) * 130, y: 220 + Math.floor(i / 6) * 130 },
      value: 10,
    })),
  ],
  startingWeapon: 'RIFLE',
  startingAmmo: 5,
  unlocks: [{ type: 'boss', id: 'boss_1' }],
};
